// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamRtpStatusCard_wrapper__K3O0D","grid":"TeamRtpStatusCard_grid__F5iT5","footnote":"TeamRtpStatusCard_footnote__7ZNSg"};